import styled from 'styled-components';

export const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const ContentSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const BadgesWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

export const Badge = styled.span`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;

  ${(props) => {
    switch (props.$type) {
      case 'status-enabled':
        return `
          background-color: #e7f3ff;
          color: #007bff;
        `;
      case 'status-disabled':
        return `
          background-color: #f5f5f5;
          color: #6c757d;
        `;
      default:
        return `
          background-color: #e7f3ff;
          color: #296BCD;
        `;
    }
  }}
`;

export const Description = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;

export const StatusInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
`;

export const StatusColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StatusLabel = styled.div`
  font-size: 13px;
  color: #666;
  font-weight: 500;
  margin-bottom: 4px;
`;

export const StatusBadgesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const StatusBadge = styled.span`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  background-color: ${(props) => (props.$changeable ? '#E0F7FA' : '#E3F2FD')};
  color: ${(props) => (props.$changeable ? '#00ACC1' : '#1976D2')};
`;

export const ActionsSection = styled.div`
  display: flex;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
`;

export const ActionButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => (props.$delete ? '#ffebee' : '#e7f3ff')};
  }
`;
